import gql from 'graphql-tag'

export const minhasUnidades = gql`query {
  minhasUnidades(page: {}) {
    id
    nome
    fracaoIdeal
    inadimplente
  }
}`

export const unidades = gql`query ($offset: Int!) {
  unidades(page: {offset: $offset}) {
    id
    nome
    tipo
    fracaoIdeal
    inadimplente
  }
}`
